// JsFromRoutes CacheKey 081b30e669fe151a5a44c8b6763cce02
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/partners'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/partners/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/partners/:id'),
}
